export default (
  state = {
    selectedOrg: undefined,
    context: null,
    questions: [],
    videos: {},
    mentorContext: null,
    myInterviewContext: null,
    hasLoadedVideos: false,
    mentorVideos: null,
  },
  { type, ...rest },
) => {
  switch (type) {
    case 'MENTOR_VIDEOS/POPULATE_SELCTEDORG':
      return {
        ...state,
        selectedOrg: rest.selectedOrg,
      };

    case 'MENTOR_VIDEOS/POPULATE_CONTEXT':
      return {
        ...state,
        context: rest.context,
      };

    case 'MENTOR_VIDEOS/POPULATE_QUESTIONS':
      return {
        ...state,
        questions: rest.questions,
      };

    case 'MENTOR_VIDEOS/POPULATE_VIDEOS':
      return {
        ...state,
        videos: rest.videos,
      };

    case 'MENTOR_VIDEOS/POPULATE_MENTOR_CONTEXT':
      return {
        ...state,
        mentorContext: rest.mentorContext,
      };

    case 'SCHOOL_PROFILE/POPULATE_MY_INTERVIEW_CONTEXT':
      return {
        ...state,
        myInterviewContext: rest.myInterviewContext,
      };

    case 'SCHOOL_PROFILE/POPULATE_MENTOR_VIDEOS':
      return {
        ...state,
        hasLoadedVideos: true,
        mentorVideos: rest.mentorVideos,
      };

    case 'CAREER_CENTER/POPULATE_MY_INTERVIEW_CONTEXT':
      return {
        ...state,
        myInterviewContext: rest.myInterviewContext,
      };

    case 'CAREER_CENTER/POPULATE_MENTOR_VIDEOS':
      return {
        ...state,
        hasLoadedVideos: true,
        mentorVideos: rest.mentorVideos,
      };

    default:
      return state;
  }
};
